import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStatusSendV4 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 9,
	viewBox: "0 0 11 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.650024 4.5L3.40002 7.5L9.40002 1.5",
		stroke: "#DFCBF5",
		strokeOpacity: .4,
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStatusSendV4;
